const intervals = [
    { i: 0, r: 0, d: true, name: "T1" },
    { i: 0, r: 1, name: "s2" },
    { i: 1, r: 0, name: "B1" },
    { i: 1, r: 1, d: true, name: "k2" },
    { i: 1, r: 2, name: "ss3" },
    { i: 2, r: 0, name: "BB1" },
    { i: 2, r: 1, d: true, name: "N2" },
    { i: 2, r: 2, name: "s3" },
    { i: 3, r: 1, name: "B2" },
    { i: 3, r: 2, d: true, name: "k3" },
    { i: 4, r: 2, d: true, name: "N3" },
    { i: 5, r: 2, name: "B3" },
    { i: 4, r: 3, name: "s4" },
    { i: 5, r: 3, d: true, name: "T4" },
    { i: 6, r: 3, d: true, name: "B4" },
    { i: 6, r: 4, name: "s5" },
    { i: 7, r: 4, d: true, name: "T5" },
    { i: 8, r: 4, name: "B5" },
    { i: 8, r: 5, d: true, name: "k6" },
    { i: 9, r: 5, d: true, name: "N6" },
    { i: 9, r: 6, name: "s7" },

    { i: 10, r: 5, name: "B6" },
    { i: 10, r: 6, d: true, name: "k7" },
    { i: 11, r: 6, d: true, name: "N7" },
    { i: 11, r: 7, name: "s8" },
    { i: 12, r: 7, d: true, name: "T8" },
    { i: 13, r: 7, name: "B8" },
    { i: 13, r: 8, d: true, name: "k9" },
    { i: 14, r: 8, d: true, name: "N9" },
    { i: 15, r: 9, d: true, name: "k10" },
    { i: 16, r: 9, d: true, name: "N10" },
    { i: 17, r: 10, d: true, name: "T11" },
    { i: 18, r: 10, d: true, name: "B11" },
    { i: 18, r: 11, name: "s12" },
    { i: 19, r: 11, d: true, name: "T8+T5" },
    { i: 20, r: 11, name: "T8+B5" },
    { i: 20, r: 12, d: true, name: "T8+k6" },
    { i: 21, r: 12, d: true, name: "T8+N6" },
    { i: 22, r: 12, name: "T8+B6" },
    { i: 22, r: 13, d: true, name: "T8+k7" },
    { i: 23, r: 13, d: true, name: "T8+N7" },
    { i: 23, r: 14, name: "T8+s8" },
    { i: 24, r: 14, d: true, name: "T8+T8" },
    { i: 25, r: 15, d: true, name: "T8+T8+k2" },
    { i: 26, r: 15, d: true, name: "T8+T8+N2" },
    { i: 27, r: 16, d: true, name: "T8+T8+k3" },
]

// not used
export const getIntervalR = (i: number) => {
    return (intervals.find(interval => interval.i === i && interval.d) || {r: 0}).r;
}

export default (i: number, r: number) => {
    if (r === undefined) { // not used currently
        return (intervals.find(interval => interval.i === i && interval.d) || {name: "?"}).name;
    }
    return (intervals.find(interval => interval.i === i && interval.r === r) || {name: "?"}).name;
};
